<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title has-text-centered">Solicitar Patrocínio</p>
    </header>

    <section class="modal-card-body">
      <form @submit.prevent="requestSponsorship">
        <b-loading
          :is-full-page="true"
          :active="isLoading"
          :can-cancel="false"
        ></b-loading>

        <b-field
          :label="request.eventInfo.eventName ? 'Nome do evento / projeto' : ''"
          label-position="on-border"
        >
          <b-input
            v-model="request.eventInfo.eventName"
            placeholder="Nome do evento / projeto"
          ></b-input>
        </b-field>

        <b-field
          :label="
            request.eventInfo.studentsCourses.length
              ? 'Cursos dos estudantes *'
              : ''
          "
          label-position="on-border"
        >
          <b-taginput
            v-model="request.eventInfo.studentsCourses"
            :data="coursesArray"
            open-on-focus
            :keep-first="false"
            :allow-new="true"
            placeholder="Cursos dos estudantes *"
          >
            <template slot-scope="props">
              {{ props.option }}
            </template>
          </b-taginput>
        </b-field>

        <div class="columns">
          <div class="column">
            <b-field
              label="Valor do patrocínio (R$)"
              label-position="on-border"
            >
              <money
                v-model="request.eventInfo.sponsorshipValue"
                v-bind="money"
                class="input is-expanded"
              ></money>
            </b-field>
          </div>
          <div class="column">
            <single-date />
          </div>
        </div>

        <b-field
          :label="
            request.eventInfo.eventDescription
              ? 'Descrição do evento / projeto a ser patrocinado'
              : ''
          "
          label-position="on-border"
        >
          <b-input
            type="textarea"
            v-model="request.eventInfo.eventDescription"
            placeholder="Descreva o evento / projeto a ser patrocinado"
          />
        </b-field>
        <span
          :style="descriptionLength >= 140 ? 'color: green' : 'color: red'"
          style="display: table; margin-left: auto;"
        >
          {{ descriptionLength }} > 140
        </span>

        <b-field
          label="Anexe um material de suporte em PDF sobre o evento / projeto"
        >
          <b-field>
            <div class="columns">
              <div class="column is-narrow">
                <button
                  type="button"
                  class="button is-empower-gray"
                  @click="$refs.pdf_sponsorship.click()"
                >
                  Anexar PDF (max. 5mb)
                </button>
                <input
                  id="pdf_sponsorship"
                  type="file"
                  ref="pdf_sponsorship"
                  style="display: none"
                  @change="handleFileUpload()"
                />
              </div>

              <div class="column">
                <p
                  v-if="filename"
                  :style="[!isMobile ? { 'margin-top': '0.4rem' } : null]"
                >
                  ✅ {{ filename }}&nbsp;
                  <a class="delete is-medium" @click="excludeFile"></a>
                </p>
              </div>
            </div>
          </b-field>
        </b-field>

        <b-field
          label="Termo de Contrapartidas *"
          custom-class="has-text-dark-grey"
        >
          <div class="field">
            <b-checkbox v-model="terms.form">
              Aceito enviar o formulário disponibilizado pela Empower a todos os
              participantes da ação.
            </b-checkbox>
            <br />
            <b-checkbox v-model="terms.photos" class="checkbox-bottom">
              Aceito enviar prints/fotos do evento / projeto patrocinado e
              coletar as devidas autorizações para uso de imagem dos
              participantes que aparecerem nos prints/fotos enviados.
            </b-checkbox>
            <br />
            <b-checkbox v-model="terms.post" class="checkbox-bottom">
              Aceito publicar um post na fanpage, insta ou linkedin da OE.
            </b-checkbox>
          </div>
        </b-field>

        <div class="has-text-centered">
          <button
            :disabled="pendencies.length || isLoading"
            class="button is-primary"
            :style="[windowWidth < 769 ? { marginBottom: 40 + 'px' } : null]"
          >
            Solicitar Patrocínio
          </button>
        </div>

        <Pendencies :pendencies="pendencies" />
      </form>
    </section>

    <footer class="modal-card-foot">
      <button class="button" type="button" @click="$parent.close()">
        Cancelar
      </button>
    </footer>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { commom } from "../../../mixins/commom";
import { responsive } from "../../../mixins/responsive";
import { request } from "../../../mixins/request";
import { cursos } from "../../../assets/js/cursos";
import singleDate from "./date-time-options/SingleDate";
import { Money } from "v-money";
import Pendencies from "../../commom/Pendencies";

export default {
  mixins: [commom, responsive, request],

  components: {
    singleDate,
    Money,
    Pendencies
  },

  data() {
    return {
      isLoading: false,

      request: {
        opportunity: null,
        requestType: "sponsorship",
        eventInfo: {
          eventName: "",
          eventDescription: "",
          sponsorshipValue: "",
          dateOptions: {
            first: {
              date: null,
              start: null,
              end: null
            }
          },
          studentsCourses: []
        }
      },

      pdf_sponsorship: "",
      filename: "",
      terms: {
        form: false,
        photos: false,
        post: false
      },
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "R$ ",
        precision: 0
      },
      coursesArray: []
    };
  },

  methods: {
    handleFileUpload() {
      this.filename = this.$refs.pdf_sponsorship.files[0].name;
      this.pdf_sponsorship = this.$refs.pdf_sponsorship.files[0];
    },

    excludeFile() {
      this.filename = "";
      this.pdf_lecture = "";
    },

    requestSponsorship() {
      if (this.pdf_sponsorship.size > 5000000) {
        this.alertError({ message: "FILE_IS_TOO_LARGE" });
        return;
      }

      this.request.eventInfo.dateOptions.first.start = this.request.eventInfo.dateOptions.first.date;
      this.request.eventInfo.dateOptions.first.end = this.request.eventInfo.dateOptions.first.date;

      let formData = new FormData();
      formData.append("pdf_sponsorship", this.pdf_sponsorship);
      formData.append("request", JSON.stringify(this.request));

      this.isLoading = true;
      this.$store
        .dispatch("makeRequest", {
          to: "sponsorship",
          data: formData
        })
        .then(res => {
          if (res.data.result === "ok") {
            this.$buefy.dialog.alert({
              title: "Solicitação de Patrocínio Recebida",
              message:
                "Sua solicitação será analisada e enviada para a empresa. A resposta pode levar algumas semanas. Em caso de dúvida, entre em contato conosco.",
              type: "is-success",
              hasIcon: true,
              icon: "check",
              iconPack: "fa",
              onConfirm: () => this.$parent.close(),
              onCancel: () => this.$parent.close()
            });
          } else {
            this.alertError(res.data);
          }
        })
        .catch(() => {
          this.alertError({ message: "UNEXPECTED_ERROR" });
        })
        .finally(() => {
          this.isLoading = false;
        });
    }
  },

  computed: {
    ...mapGetters(["opportunityBeingVisited"]),

    pendencies() {
      const pendencies = [];

      if (!this.terms.form || !this.terms.photos || !this.terms.post) {
        pendencies.push("Aceitar termos de contrapartidas");
      }

      if (!this.request.eventInfo.eventName) {
        pendencies.push("Nome do evento / projeto");
      }

      if (this.request.eventInfo.studentsCourses.length < 1) {
        pendencies.push("Informe os cursos dos estudantes");
      }

      if (!this.request.eventInfo.sponsorshipValue) {
        pendencies.push("Valor do patrocínio (R$)");
      }

      if (!this.request.eventInfo.dateOptions.first.date) {
        pendencies.push("Data da necessidade da verba");
      }

      if (!this.request.eventInfo.eventDescription) {
        pendencies.push("Descreva o evento / projeto a ser patrocinado");
      } else if (this.request.eventInfo.eventDescription.length < 140) {
        pendencies.push("A descrição precisa ter no mínimo 140 caracteres");
      }

      return pendencies;
    },

    descriptionLength() {
      return this.request.eventInfo.eventDescription.length;
    }
  },

  mounted() {
    this.coursesArray = cursos;
    
    this.request.opportunity = this.opportunityBeingVisited._id;
  }
};
</script>

<style scoped>
.modal-card-body {
  padding-top: 3rem;
  padding-bottom: 3rem;
}
.checkbox-bottom {
  padding-top: 0.5rem;
}
</style>
